import * as Highcharts from 'highcharts';
import { ChartOptions } from './high-chart-config';

export class BarChartConfig {
  static getBarChartOptions(options: ChartOptions): Highcharts.Options {
    const {
      data,
      categories,
      yAxisTitle,
      tooltipFormatter,
      colors,
      showLegend,
      ...standardOptions
    } = options;

    const dataLength = (data || []).length;
    let pointWidth;
    if (dataLength < 8) {
      pointWidth = undefined;
    } else {
      pointWidth = 30;
    }

    const baseGeneratedOptions: Highcharts.Options = {
      chart: {
        type: 'bar',
      },
      title: {
        text: null as any,
      },
      xAxis: {
        categories: categories || [],
        allowDecimals: true,
        title: {
          text: null,
        },
        lineWidth: 0,
        labels: {
          enabled: true,
          formatter: function () {
            const point = (this.chart.series[0].data as Highcharts.PointOptionsObject[])?.find(
              d => d.label === String(this.value) || d.y?.toString() === String(this.value)
            );
            return point?.label || String(this.value);
          },
          style: {
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            width: 100,
          },
        },
        gridLineWidth: 0,
        visible: true,
      },
      yAxis: {
        min: 0,
        allowDecimals: true,
        title: {
          text: yAxisTitle || '',
          align: 'high',
        },
        gridLineWidth: 0,
        visible: false,
      },
      tooltip: {
        enabled: true,
        useHTML: true,
        formatter: tooltipFormatter
          ? function (this: Highcharts.Point) {
              return tooltipFormatter!(this as Highcharts.Point);
            }
          : function (this: Highcharts.Point) {
              const pointOptions = this.options as any;
              return `
                 <b>${pointOptions.label || this.category || this.key}</b><br/>
                ${this.series.name}: <b>${this.y}</b>
              `;
            },
      },
      plotOptions: {
        bar: {
          pointWidth: pointWidth,
          borderWidth: 0,
          pointPadding: 0.1,
          color: 'var(--primary-30)',
          states: {
            hover: {
              color: 'var(--primary-50)',
            },
          },
        },
        series: {
          dataLabels: [
            {
              enabled: true,
            },
            {
              enabled: false,
              align: 'left',
              inside: false,
              formatter: function () {
                return this.category;
              },
              style: {
                fontSize: 'var(--h4-reg)',
                fontWeight: 'normal',
                textOutline: 'none',
              },
            },
          ],
        },
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          type: 'bar',
          allowDecimals: true,
          showInLegend: showLegend,
          name: 'Values',
          data: (data || []).map(item => {
            const { y, label, color, ...rest } = item;
            return {
              y: y,
              name: label ?? 'null',
              label: label ?? 'null',
              color: color,
              ...rest,
            };
          }),
        } as Highcharts.SeriesBarOptions,
      ],
      legend: {
        enabled: showLegend || false,
      },
      colors: colors,
    };

    return Highcharts.merge(baseGeneratedOptions, standardOptions);
  }
}
